import type { MutationCallbacks } from '#shared'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { PERSONAL_CHATS_QUERY_KEY, type Chat } from '#entities/chat'
import { getMessagesQueryOptions } from '#entities/message'
import { createChat } from '../api/create-chat'

type CreateChatMutationCallbacks = MutationCallbacks<number, Chat>

export function useCreateChatMutation(callbacks: CreateChatMutationCallbacks = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...callbacks,

    mutationFn: createChat,

    onSuccess: async (chat, payload) => {
      await queryClient.invalidateQueries({ queryKey: PERSONAL_CHATS_QUERY_KEY })
      await queryClient.prefetchInfiniteQuery(getMessagesQueryOptions(chat.id))

      callbacks.onSuccess?.(chat, payload)
    },
  })
}
